import { ComboBox } from "../../../core/components/comboBox";
import { DatePicker } from "../../../core/components/datePicker";
import { Dialog, DialogProps } from "../../../core/components/dialog";
import { FieldInstance } from "../../../core/components/field";
import { IsNumericTextBox } from "../../../core/components/isNumericTextBox";
import { TextBox } from "../../../core/components/textBox";
import { Config } from "../../../core/config/config";
import { ComponentHelper } from "../../../core/util/componentHelper";
import { Helper } from "../../../core/util/helper";
import { NotificationHelper } from "../../../core/util/notificationHelper";
import React from "react";
import ReactDOM from "react-dom";

export const OpenCurrencyDialog = (sourceCurrency: Currency = null) => {
    return new Promise<Currency>((resolve) => {
        const targetElement = $("<div>");
        const props: any = {
            onOk: (currency: Currency) => {
                resolve(currency)
            },
            onCancel: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            },
            currency: sourceCurrency,
            editExisting: Helper.hasValue(sourceCurrency)
        }
        $("body").append(targetElement);
        ReactDOM.render(<CurrencyDialog {...props} />, targetElement[0]);
    })
}

class CurrencyDialog extends React.Component<{
    onOk: (currency: Currency) => void;
    onCancel: () => void;
    currency: Currency;
    editExisting: boolean;
}, {
    from: Date,
    currency: string,
    character: string,
    factor: number,
    name: string
}>{
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this.checkCurrency()) {
                        this.onOk();
                    }
                    else {
                        NotificationHelper.showErrorMessage(Helper.getTranslation("Standard.PflichtfeldAllgemein"));
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: 500
    };

    private checkCurrency = () => {
        return (Helper.hasValue(this.state.factor) && (this.state.factor > 0) && !Helper.isNullOrEmpty(this.state.character) && !Helper.isNullOrEmpty(this.state.currency) && !Helper.isNullOrEmpty(this.state.name));
    }

    constructor(props) {
        super(props);
        this.state = {
            from: this.props.currency?.From,
            currency: this.props.currency?.Currency,
            character: this.props.currency?.Characters,
            factor: this.props.currency?.Factor,
            name: this.props.currency?.Name
        }
    }

    private onOk = () => {
        let currency: Currency = {
            Currency: this.state.currency,
            From: this.state.from,
            Name: this.state.name,
            Characters: this.state.character,
            Factor: this.state.factor
        };
        this.props.onOk(currency);
    }

    private createComboBox = () => {
        let props = this._factory.getDefaultComboBoxProps();
        props.value = this.state.currency ?? "";
        props.field.dataSourceUrl = "GeneralSettingsCurrency/GetDistinctCurrenciesList";
        props.field.dataTextField = "Currency";
        props.field.dataValueField = "Currency";
        props.disabled = this.props.editExisting;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            this.setState({ currency: value, character: dataItem?.Zeichen, name: dataItem?.Bezeichnung });
        }
        return (
            <FieldInstance label={Helper.getTranslation("WebSMS.GeneralSettings.Currency.Currency") + "*"} noHover={true} >
                <ComboBox {...props} />
            </FieldInstance>
        );
    }

    private createTextBox = (label: string, value: string, onChange: (_, value: any) => void) => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = value;
        props.onChange = onChange;
        return (
            <FieldInstance label={label} noHover={true} >
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private createNumericPicker = (label: string, value: number, onChange: (_, value: any) => void) => {
        let props = this._factory.getDefaultNumericTextBoxProps();
        props.value = value;
        props.onChange = onChange;
        return (
            <FieldInstance label={label} noHover={true} >
                <IsNumericTextBox {...props} />
            </FieldInstance>
        );
    }

    private createDatePicker = (type: "from") => {
        let props = this._factory.getDefaultDatePickerProps();
        props.disabled = this.props.editExisting;
        let labelCode: string;
        if (type == "from") {
            props.value = this.state.from;
            labelCode = "Standard.Von";
            props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                this.setState({ from: value });
            };
        }
        return (
            <FieldInstance label={Helper.getTranslation(labelCode) + "*"} noHover={true}>
                <DatePicker {...props} />
            </FieldInstance>
        );
    }

    render() {
        return (<>
            <div>
                <Dialog {...this._dialogProps} open={true}>
                    {this.createComboBox()}
                    {this.createDatePicker("from")}
                    {this.createTextBox(Helper.getTranslation("WebSMS.GeneralSettings.Currency.Characters") + "*", this.state.character, (_, value) => { this.setState({ character: value }) })}
                    {this.createTextBox(Helper.getTranslation("Standard.Beschreibung") + "*", this.state.name, (_, value) => { this.setState({ name: value }) })}
                    {this.createNumericPicker(Helper.getTranslation("WebSMS.GeneralSettings.Currency.ExchangeRate") + "*", this.state.factor, (_, value) => { this.setState({ factor: value }) })}
                </Dialog>
            </div>
        </>)
    }
}

export interface Currency {
    Id?: number;
    Currency?: string;
    Characters?: string;
    Factor?: number;
    From?: Date;
    Name?: string;
    GUID?: string;
    IsNew?: boolean;
    IsDeletable?: boolean;
}